const NotificationType = Object.freeze({
  CaseMessageUpdate: 'CaseMessageUpdate',
  CaseStatusUpdate: 'CaseStatusNotification',
});

export default NotificationType;
